/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Build_NavInputs */

const en_how_we_work_build_nav = /** @type {(inputs: How_We_Work_Build_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make it work in practice`)
};

const lv_how_we_work_build_nav = /** @type {(inputs: How_We_Work_Build_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panākam, ka tas strādā praksē`)
};

/**
* | output |
* | --- |
* | "Make it work in practice" |
*
* @param {How_We_Work_Build_NavInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_build_nav = /** @type {((inputs?: How_We_Work_Build_NavInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Build_NavInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_build_nav(inputs)
	return en_how_we_work_build_nav(inputs)
});